export default class Vacancy {
  constructor(item, lang) {
    this._setId(item);
    this._setImage(item);
    this._setDescription(item, lang);
    this._setTitle(item, lang);
  }

  /**
   * set id
   * @param {id} param0
   */
  _setId({ id }) {
    this.id = id;
  }

  /**
   * set image
   * @param {photoUrl} param0
   */
  _setImage({ photoUrl }) {
    this.image = photoUrl;
  }

  /**
   * set title
   * @param {vacancy} item
   * @param {language} lang
   */
  _setTitle(item, lang) {
    let key = "name_" + lang;
    this.title = item[key];
  }

  /**
   * set description
   * @param {vacancy} item
   * @param {language} lang
   */
  _setDescription(item, lang) {
    let key = "description_" + lang;
    this.description = item[key];
  }
}
